import request from '@/api/request'



const url_permission_list = "/api/manager/permission/list";


export function getListApi(params) {

  let data = {
    rid: params.cid
  }

  return request({
    url: url_permission_list,
    method: 'post',
    data
  })
}



